<template>
  <div>
    <div v-if="b2b && b2c" class="flex q-px-lg q-pt-md">
      <span><q-select outlined style="width:200px" class="select" v-model="model" :options="options" label="Operator" @input="changeReport" /></span>
    </div>
    <TradingOverview :reportData="reportData" v-if="reportData" />
  </div>
</template>

<script>
import TradingOverview from "@/views/reports/powerbi/TradingOverviewReport.vue";
export default {
  name: "TradingOverviewPage",
  components: { TradingOverview },
  data() {
    return {
      b2b: null,
      b2c: null,
      reportData: null,
      model: "B2B",
      options: ["B2B", "B2C"],
    };
  },
  methods: {
    changeReport(){
      this.reportData = this.model === "B2B"?this.b2b:this.b2c;
    }
  },
  mounted(){
    if(this.$store.getters.getHasB2BRole){
      this.b2b = this.$router.currentRoute.meta.b2b;
    }
    if(this.$store.getters.getHasB2CRole){
      this.b2c = this.$router.currentRoute.meta.b2c;
    }
    if(this.b2b){
      this.reportData = this.b2b;
    }else if(this.b2c){
      this.reportData = this.b2c;
    }
  }
};
</script>
